import { render, staticRenderFns } from "./transaction-summary.vue?vue&type=template&id=656ec9e8"
import script from "./transaction-summary.vue?vue&type=script&lang=js"
export * from "./transaction-summary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports